module.exports = __webpack_public_path__ + "static/media/(V)_MG_6120_-_capim_dourado_-_bijuterias.f2d087a2.jpg";